<div class="restaurant-container">
  <app-restaurant-header></app-restaurant-header>

  <nav class="breadcrumbs" *ngIf="breadcrumbs?.length > 0">
    <a routerLink="/">Home</a>
    <ng-container *ngFor="let b of breadcrumbs; let last = last">
      <span class="separator">/</span>
      <ng-container *ngIf="!last">
        <a [routerLink]="b.url">{{ b.label }}</a>
      </ng-container>
      <ng-container *ngIf="last">
        <span>{{ b.label }}</span>
      </ng-container>
    </ng-container>
  </nav>

  <div class="status-indicator"></div>
  
  <div class="main-content">
  <ng-container *ngIf="items?.length > 0; else loadingShimmer">
    <ng-container *ngFor="let item of items">
      <app-food-item [item]="item"></app-food-item>
    </ng-container>
  </ng-container>

  <ng-template #loadingShimmer>
    <div *ngFor="let i of [1,2,3,4,5]" class="shimmer-list-item">
      <div class="shimmer-inner"></div>
    </div>
  </ng-template>
</div>

  <div class="bottom-indicator">
    <div class="indicator-line"></div>
  </div>
</div>